export var ProposalProcessStatus;
(function (ProposalProcessStatus) {
    ProposalProcessStatus[ProposalProcessStatus["DocumentProcessing"] = 0] = "DocumentProcessing";
    ProposalProcessStatus[ProposalProcessStatus["DocumentProcessed"] = 1] = "DocumentProcessed";
    ProposalProcessStatus[ProposalProcessStatus["Failed"] = 2] = "Failed";
})(ProposalProcessStatus || (ProposalProcessStatus = {}));
export const ActionTypeMapping = new Map([
    [ProposalProcessStatus.DocumentProcessing, 'DocumentProcessing'],
    [ProposalProcessStatus.DocumentProcessed, 'DocumentProcessed'],
    [ProposalProcessStatus.Failed, 'Failed']
]);
